import styled from 'styled-components';

import Banner from '@mindtickle/banner';
import { tokens, textStyles } from '@mindtickle/styles/lib';

import { getBannerStyles } from './utils';

export const StyledBanner = styled(Banner)`
  &&& {
    width: 100%;
    z-index: 1000;
    padding: 8px 24px;
    border-bottom: ${({ bannerType }) => getBannerStyles(bannerType).border};
    background-color: ${({ bannerType }) => getBannerStyles(bannerType).background};

    && .header-alert-icon {
      color: ${tokens.iconTokens.COLOR_ICON_DEFAULT};
    }

    && .banner-text {
      ${textStyles.bodyMediumDefault};
    }

    && .icon-wrapper-el {
      font-size: 16px;
      color: ${({ bannerType }) => getBannerStyles(bannerType).icon};
      &.banner-close-icon {
        color: ${tokens.iconTokens.COLOR_ICON_DEFAULT};
      }
    }
  }
`;
